var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6349_3020)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9833,
    height: 19.9833,
    rx: 4.48843,
    fill: "url(#paint0_linear_6349_3020)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7403 6.03848H5.12134V7.96265H11.814C12.4277 7.96265 12.4856 8.43804 12.4856 9.03792C12.4856 9.63781 12.4277 10.1132 11.814 10.1132H5.12134V13.9615H7.58766V12.0374H12.7403C14.4424 12.0374 14.8593 10.6904 14.8593 9.03792C14.8593 7.3854 14.4424 6.03848 12.7403 6.03848Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6349_3020",
    x1: 19.9833,
    y1: 9.95554,
    x2: -3.99948e-7,
    y2: 10.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#561327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#943829"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6349_3020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconLogo);
export default __webpack_public_path__ + "static/media/app-icon-logo.db4a5e114cec8b0fd0dad783351198ee.svg";
export { ForwardRef as ReactComponent };